import bluWaveLogo from '../assets/whiteBWLogo.png';

const Sidebar = () => {
  return (
    <div className="w-[180px] min-h-screen bg-[#29446d] text-white fixed left-0 top-0 z-10">
      <div className="px-4 pt-5 pb-6">
        <img
          src={bluWaveLogo}
          alt="BluWave Logo"
          className="w-[150px]"
          style={{ aspectRatio: '192.4/42', objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};

export default Sidebar;
